import { render, staticRenderFns } from "./PopupExtendIdCard.vue?vue&type=template&id=9053d2ee&scoped=true&"
import script from "./PopupExtendIdCard.vue?vue&type=script&lang=js&"
export * from "./PopupExtendIdCard.vue?vue&type=script&lang=js&"
import style0 from "./PopupExtendIdCard.vue?vue&type=style&index=0&id=9053d2ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9053d2ee",
  null
  
)

export default component.exports